import httpClient from "./httpClient";
import { AxiosResponse } from "axios";
import DnaValidation from "@/model/dnaValidation";

export default class DnaValidationService {
  static validDna(dna: DnaValidation): Promise<AxiosResponse<DnaValidation>> {
    return httpClient.post(`/validDna/`, dna);
  }
}
